import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import { TextField } from '@material-ui/core';

export const AutoCompleteSelectField = props => {
    const {
        id,
        title,
        options,
        emptyValue,
        error,
        placeholder,
        errorText,
        helperText,
        required,
        disabled,
        multiple,
        inputValue,
        onBlur,
        onFocus,
        valueOptions,
        uiSchema,
        noOptionsText
    } = props;

    const { classes = {} } = uiSchema;
    const onChange = (event, value) => {

        // MUI multiple selects returns array,
        // to handle the same way, extract the selected options
        if (!multiple) {
            return props.onChange(id, value === null ? emptyValue : value.key);
        }

        // extract the selected value keys
        const selectedValues = value.map(val => val.key);

        return props.onChange(id, selectedValues);
    };

    let inputValueObjects;

    if (multiple) {
        inputValueObjects = [];

        inputValue.forEach(key => {
            for (let i = 0; i < valueOptions.length; i++) {
                if (valueOptions[i].key === key) {
                    inputValueObjects.push(valueOptions[i]);
                }
            }
        });
    } else {
        for (let i = 0; i < valueOptions.length; i++) {
            if (valueOptions[i].key === inputValue) {
                inputValueObjects = valueOptions[i];
                break;
            }
        }
    }

    return (
        <React.Fragment>
            <FormControl
                required={ required }
                error={ error }
                component="fieldset"
                variant={ options.variant || 'outlined'}
                classes={{
                    root: classes.fieldSet || ''
                }}
            >
                <Autocomplete
                    id={ id }
                    label={ title }
                    classes={{
                        root: classes.selectField || ''
                    }}
                    multiple={ multiple }
                    variant={ options.variant ? options.variant : 'outlined' }
                    onChange={ !disabled ? onChange : null }
                    placeholder={ placeholder }
                    required={ required }
                    disabled={ disabled }
                    value={ inputValueObjects || '' }
                    onBlur={ onBlur && (event => onBlur({ id, value: event.target.value })) }
                    onFocus={ onFocus && (event => onFocus({ id, value: event.target.value })) }
                    size={ options.size || null }
                    options={ valueOptions }
                    getOptionLabel={ option => option.label || '' }
                    renderTags={ (value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip
                                variant={ options.chipVariant || 'default' }
                                label={ option.label }
                                size={ options.size || null }
                                { ...getTagProps({ index }) }
                            />
                        ))
                    }
                    noOptionsText={ noOptionsText }
                    renderInput={ params => (
                        <TextField
                            { ...params }
                            variant={ options.inputVariant || 'outlined' }
                            label={ title }
                            placeholder={ placeholder }
                        />
                    )}
                />
                { helperText ? <FormHelperText
                    classes={{
                        root: classes.helperContainer || ''
                    }}
                >{ helperText }</FormHelperText> : null }
                { errorText ? <FormHelperText
                    classes={{
                        root: classes.errorContainer || ''
                    }}
                >{ errorText }</FormHelperText> : null }
            </FormControl>
        </React.Fragment>
    );
};

AutoCompleteSelectField.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    emptyValue: PropTypes.any,
    placeholder: PropTypes.any,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    options: PropTypes.shape({
        variant: PropTypes.oneOf(['filled', 'outlined']),
        inputVariant: PropTypes.oneOf(['filled', 'outlined']),
        chipVariant: PropTypes.oneOf(['default', 'outlined']),
        size: PropTypes.string
    }),
    valueOptions: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        label: PropTypes.string.isRequired,
        disabled: PropTypes.bool
    })),
    uiSchema: PropTypes.shape({
        classes: PropTypes.shape({
            fieldSet: PropTypes.string,
            helperContainer: PropTypes.string,
            errorContainer: PropTypes.string,
            selectField: PropTypes.string,
            chipContainer: PropTypes.string,
            chip: PropTypes.string
        })
    }),
    inputValue: PropTypes.any,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    helperText: PropTypes.string,
    onChange: PropTypes.func,
    noOptionsText: PropTypes.string
};

AutoCompleteSelectField.defaultProps = {
    title: '',
    emptyValue: '',
    placeholder: null,
    error: false,
    errorText: '',
    required: false,
    disabled: false,
    multiple: false,
    options: {
        variant: 'outlined',
        inputVariant: 'outlined',
        chipVariant: 'default',
        size: 'small'
    },
    valueOptions: [],
    uiSchema: {},
    inputValue: '',
    helperText: '',
    noOptionsText: ''
};
